@if ((useLazyLoad && !isLoaded) || ((!!title && (!!mediaTop || !!mediaBottom) && !!content) || !isProductOrBundle)) {
  <wc-wrapper [contentWrapper]="wrapper" [componentWidth]="componentWidth" [marginSize]="marginSize">
    <sd-wysiwyg
      sd-component-wrapper-component
      [sdSpyTarget]="componentUid"
      [layout]="layout"
      [title]="title"
      [titleLevel]="titleLevel"
      [textConfig]="textConfig"
      [links]="links"
      [mediaConfig]="mediaConfig"
      [ratioMediaTop]="ratioMediaTop"
      [ratioMediaBottom]="ratioMediaBottom"
      [mediaTop]="mediaTop"
      [mediaBottom]="mediaBottom"
      [titleThemeConfig]="themeWyziwyg"
      [parentsThemesConfig]="wrapperBackgroundTheme"
      (linkClicked)="onLinkClick($event)"
      [twicPicsAutoSize]="!isFirst"
      [brand]="brandCorner"
      [isLoading]="useLazyLoad && !isLoaded"
      (mediaPlay)="onMediaPlay($event)"
    >
      @if (isProductOrBundle) {
        <sd-wysiwyg-paragraph [content]="content" [isLoading]="useLazyLoad && !isLoaded" />
      } @else {
        @for (wysiwyg of wysiwygComponents; track wysiwyg.index) {
          @if (!wysiwyg?.isTips) {
            <sd-wysiwyg-paragraph
              [content]="wysiwyg?.component?.content"
              [title]="wysiwyg?.component?.title"
              [isLoading]="useLazyLoad && !isLoaded"
              [titleLevel]="transformHeadlineLevelToTitleLevel(wysiwyg?.component?.titleLevel)"
            />
          }
          @if (wysiwyg?.isTips && firstTips === $index) {
            <sd-tips
              [content]="wysiwyg?.component?.content"
              [title]="wysiwyg?.component?.title"
              [icon]="icon"
              [brand]="brandCorner"
              [isLoading]="useLazyLoad && !isLoaded"
            />
          }
        }
      }
    </sd-wysiwyg>
  </wc-wrapper>
}
